import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

type PropsType = SVGComponentPropsType & {
  title?: string;
};

export default ({ color = defaultIconColor, title = '', size = defaultSize, ...props }: PropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    {title && <title>{title}</title>}
    <g transform="translate(2 6)" stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <rect width="20" height="13" rx="1" />
      <path d="M0 4h20M11 9h6" />
    </g>
  </svg>
);
